// extracted by mini-css-extract-plugin
export default {"container":"il-z","bubbleNav":"jl-z","graphic":"kl-z","contact":"ll-z"};